import { getInstance } from "shared/i18n";
import { Module, TitlelessModule } from "../types";

const modules: { [k: string]: TitlelessModule } = {
  base_crm: {
    name: "base",
    icon: "icon-compenda bg",
    bundle: "lite"
  },
  base_tasks: {
    name: "base",
    icon: "tasks",
    bundle: "lite"
  },
  base_calendar: {
    name: "base",
    icon: "calendar-alt",
    bundle: "lite"
  },
  base_archive: {
    name: "base",
    icon: "archive",
    bundle: "lite"
  },
  emailing: {
    name: "emailing",
    icon: "envelope",
    bundle: "lite",
    hide: true
  },
  multi_language: {
    name: "multi_language",
    icon: "language",
    bundle: "lite"
  },
  outlook: {
    name: "outlook",
    icon: "at",
    bundle: "lite"
  },
  planner: {
    name: "planner",
    icon: "calendar-edit",
    bundle: "lite"
  },
  procedures: {
    name: "procedures",
    icon: "link",
    bundle: "lite"
  },
  specific_fields: {
    name: "specific_fields",
    icon: "layer-plus",
    bundle: "lite"
  },
  tapi: {
    name: "tapi",
    icon: "phone-office",
    bundle: "lite",
    hide: true
  },
  fin_exact: {
    name: "fin_exact",
    icon: "link",
    bundle: "lite"
  },
  fin_exact_online: {
    name: "fin_exact_online",
    icon: "link",
    bundle: "lite"
  },
  fin_snelstart: {
    name: "fin_snelstart",
    icon: "link",
    bundle: "lite"
  },
  fin_snelstart_online: {
    name: "fin_snelstart_online",
    icon: "link",
    bundle: "lite"
  },
  fin_twinfield: {
    name: "fin_twinfield",
    icon: "link",
    bundle: "lite"
  },
  orders: {
    name: "orders",
    icon: "shopping-cart",
    bundle: "complete"
  },
  quotations: {
    name: "orders",
    icon: "handshake",
    bundle: "complete"
  },
  project_project: {
    name: "project",
    icon: "project-diagram",
    bundle: "complete"
  },
  project_timesheets: {
    name: "project",
    icon: "user-clock",
    bundle: "complete"
  },
  project_hrm: {
    name: "project",
    icon: "users",
    bundle: "complete"
  },
  invoice: {
    name: "invoice",
    icon: "file-invoice",
    bundle: "complete"
  },
  automatic_collection: {
    name: "automatic_collection",
    icon: "magic",
    bundle: "complete"
  },
  logistics: {
    name: "logistics_active",
    icon: "truck-loading",
    bundle: "a-la-carte"
  },
  multi_admin: {
    name: "multi_admin_active",
    icon: "database",
    bundle: "a-la-carte"
  },
  multi_invoice: {
    name: "multi_invoice_active",
    icon: "sitemap",
    bundle: "a-la-carte"
  }
};

const i18n = getInstance();

function addTexts(mods: {
  [k: string]: TitlelessModule;
}): { [k: string]: Module } {
  const res: { [k: string]: Module } = {};
  Object.keys(mods).forEach((k: string): void => {
    res[k] = {
      ...mods[k],
      title: i18n.t("compendalicense.modules." + k + ".title").toString(),
      subtitle: i18n
        .t("compendalicense.modules." + k + ".description")
        .toString()
    };
  });

  return res;
}

export default addTexts(modules);
